/* esm.sh - @noble/hashes@1.8.0/esm/_u64 */
export * from "/*@noble/hashes@1.8.0/esnext/esm/_u64.mjs";
export { default } from "/*@noble/hashes@1.8.0/esnext/esm/_u64.mjs";
